export const PAGE_NAME = "Lora Control s.r.o";
